import axios, { type AxiosInstance } from 'axios';

import { getAppContext } from './app-context';

/**
 * 后端调用入口。
 *
 * 遇到 401 直接带上当前地址跳飞书授权，回来还落在原页面。
 */

/** 站内基础路径；部署在子路径下时由构建期注入 */
export const BASE_PATH: string = process.env.CLIENT_BASE_PATH || '/';

function buildLoginUrl(): string {
  const returnTo: string = window.location.pathname + window.location.search;
  const loginUrl: string = getAppContext().loginUrl;
  return `${loginUrl}?return_to=${encodeURIComponent(returnTo)}`;
}

function createInstance(): AxiosInstance {
  const instance: AxiosInstance = axios.create({
    baseURL: BASE_PATH,
    // 会话在 httpOnly Cookie 里，跨子路径也要带上
    withCredentials: true,
  });

  instance.interceptors.response.use(null, (error: unknown) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // 会话过期后继续停在页面上只会连续报错，直接送去重新登录
      window.location.href = buildLoginUrl();
    }
    return Promise.reject(error);
  });

  return instance;
}

export const axiosForBackend: AxiosInstance = createInstance();

/** 主动跳转登录页，退出登录后调用 */
export function redirectToLogin(): void {
  window.location.href = buildLoginUrl();
}
